// extracted by mini-css-extract-plugin
module.exports = {"shopifyMsdCta":"shopify-msd-cta__shopifyMsdCta___3gxnB"};